import { Fade } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { CardOverlay } from './RequestCardOverlay.styles';
import { RequestCardOverlayProps } from './RequestCardOverlay.types';

export const RequestCardOverlay = memo<RequestCardOverlayProps>((props) => {
    const { activeRequestId } = props;

    return (
        <Fade in={true} timeout={250} config={{ duration: 500 }} enter={{ opacity: 0.5 }} key={activeRequestId}>
            <CardOverlay />
        </Fade>
    );
});

RequestCardOverlay.displayName = 'RequestCardOverlay';
